var MDB = window.MDB || {};

(function() {
    $.extend(MDB, {
        initMdbFileUploads: function(selector) {
            selector = $(selector || 'body');

            selector.find('[data-type="fileupload"]').each(function () {
                var me = $(this);
                var existingList = $('#' + me.data('target')); //List of filenames from the model.

                me.kendoUpload({
                    async: {
                        saveUrl: me.data('save'),
                        removeUrl: me.data('remove'),
                        batch: true
                    },
                    success: function (response) {

                        //response is the default kendo response. response.response (i know) is a custom json response.
                        //There is an actionmethod in the baseController that can be used for this (SaveFiles).
                        //Or you could write your own.
                        var files = response.response.files || response.files;
                        var errors = response.response.errors;

                        if(errors && errors.length > 0) {
                            MDB.Notify.bootstrapDanger(errors.join('<br />'));
                        }

                        files.forEach(function (file) {
                            //The input that is serialized for the model. Contains the filenames.
                            existingList.append('<option value="' + file.name + '" selected="selected">' + file.name + '</option>');

                            //Append a file row to our dropzone.
                            appendFileToZone(me, file.name, zone, existingList);
                        });
                    },
                    error: function (errors) {
                        MDB.Notify.bootstrapDanger(MDB.loadResourceString('Dpn_CampaignManager_Advanced_Upload_File_Error_Text'));
                        me.parent().unbind('click');
                    }, 
                    upload: function (e) {
                        //if a data-id is set for the input, send the id to the controller with the files.
                        if(me.data('id')) {
                            e.data = {
                                id: me.data('id')
                            };
                        }
                    },
                    showFileList: false
                });

                ///init our custom dropzone.
                var zone = initDropzone(me.parent(), me.data('text'), existingList);

                //Append a file row to our dropzone for existing files.
                if(existingList.val()) {
                    existingList.val().forEach(function (item) {
                        appendFileToZone(me, item, zone, existingList);
                    });
                }
            });

            function appendFileToZone(fileupload, filename, zone, existingList) {
                var preview = zone.find('[data-role="files-preview"]');

                preview.append([
                    '<div data-name="'+filename+'" class="row file-row">',
                        '<div class="col-12 file">',
                            '<div class="row">',
                                '<div class="col-10 file-wrap-ellipsis">',
                                    '<div data-role="overlay"></div>',
                                    getFileIcon(filename),
                                    '<span class="fileupload-filename">&nbsp;&nbsp;'+filename+'</span>',
                                '</div>',
                                '<div class="col-1 file-controls"></div>',
                            '</div>',
                        '</div>',
                    '</div>'].join(''));

                if(fileupload.data('download')) {
                    appendDownloadButton(preview, fileupload, filename, existingList);
                    preview.find('.file').last().find('.file-controls').append('&nbsp;&nbsp;');
                }

                appendDeleteButton(preview, zone, fileupload, filename, existingList);

                if(zone.find('[data-role="delete-all"]').length === 0) {
                    appendDeleteAllButton(zone, existingList);
                }
            }

            function appendDeleteButton(preview, dropzone,  fileupload, filename, existingList) {
                var deleteBtn = $('<a href="javascript:void(0)" class="mdb-icon-btn delete" data-role="delete"><i class="fa fa-trash-o"></i></a>');
                preview.find('.file').last().find('.file-controls').append(deleteBtn);

                deleteBtn = preview.find('[data-role="delete"]').last();
                var overlay = deleteBtn.closest('.file').find('[data-role="overlay"]');

                deleteBtn.click(function () {
                    var row = deleteBtn.parents('.file-row').first();

                    promptDelete(filename, function() {
                        var option = existingList.find('[value="' + filename + '"]');
                        
                        deleteFile(dropzone, fileupload, filename, row, option);
                    });
                });

                deleteBtn.mouseenter(function() {
                  overlay.addClass('file-delete-overlay');
                });

                deleteBtn.mouseleave(function() {
                  overlay.removeClass('file-delete-overlay');
                });
            }

            function appendDownloadButton(preview, fileupload, filename, existingList) {
                var downloadBtn = $('<a href="javascript:void(0)" class="mdb-icon-btn" data-role="download"><i class="fa fa-download"></i></a>');
                preview.find('.file').last().find('.file-controls').append(downloadBtn);

                downloadBtn = preview.find('[data-role="download"]').last();
                var overlay = downloadBtn.closest('.file').find('[data-role="overlay"]');

                downloadBtn.click(function () {
                    downloadFile(fileupload, filename);
                });

                downloadBtn.mouseenter(function() {
                  overlay.addClass('file-download-overlay');
                });

                downloadBtn.mouseleave(function() {
                  overlay.removeClass('file-download-overlay');
                });
            }

            function getFileIcon(extension) {
                return MDB.Icons.getFileIcon(extension);
            }

            //todo this is a bit of a mess.
            function initDropzone(kendoBtn, dropzoneText, existingList) {
                kendoBtn.hide();

                var button = $('<button class="btn btn-bootstrap-primary btn-sm pull-left"> ' + MDB.loadResourceString('Button_AddFiles') + '</button>')

                button.unbind('click');
                button.click(function (e) {
                    e.preventDefault();
                    kendoBtn.find('input').click();
                });

                button.insertAfter(kendoBtn);

                var dropzone = button.parent();
                dropzone.removeClass('k-dropzone');
                dropzone.addClass('dropZoneElement');
                dropzone.addClass('mdb-dropzone');

                dropzone.append('<br /><br /><div data-role="files-preview"></div>')

                var container = dropzone.parent();
                container.removeClass('k-upload');
                container.removeClass('k-widget');
                container.removeClass('k-upload-empty');

                var title = dropzone.find('em');
                title.html('&nbsp;&nbsp;' + dropzoneText);

                if(existingList.find('option').length > 0 ) {
                    appendDeleteAllButton(dropzone, existingList);
                }

                return dropzone;
            }

            function appendDeleteAllButton(dropzone, existingList) {
                
                var title = dropzone.find('em');

                var deleteTemplate = [
                    '<div class="pull-right delete-all-btn">',
                        '<a href="javascript:void(0)" class="mdb-icon-btn delete" data-role="delete-all">',
                            '<i class="fa fa-trash-o" style="font-size:large;"></i>',
                        '</a>',
                    '</div>'
                    ].join('');

                var delBtn = $(deleteTemplate).insertAfter(title);

                delBtn.mouseenter(function () {
                    dropzone.find('[data-role="delete"]').mouseenter();
                });

                delBtn.mouseleave(function () {
                    dropzone.find('[data-role="delete"]').mouseleave();
                });

                delBtn.click(function () {
                    MDB.promptWithIcon(
                        MDB.loadResourceString('FileUpload_Delete_All_Title'),
                        MDB.loadResourceString('FileUpload_Delete_All_Body'),
                        'fa fa-trash-o text-danger',
                        function (ok) {
                            if(ok) {
                                deleteAllFiles(dropzone, existingList);
                            }
                        });
                });
            }

            function deleteAllFiles(dropzone, existingList) {
                
                var fileupload = dropzone.find('[data-type="fileupload"]');

                dropzone.find('.file').each(function (){
                    
                    var row =  $(this).closest('.file-row');
                    var filename = row.data('name');
                    var option = existingList.find('[value="' + filename + '"]');

                    deleteFile(dropzone, fileupload, filename, row, option);
                });
            }

            function deleteFile(dropzone, fileupload, filename, row, option) {
                var prom = $.Deferred(function(def){
                    var deleteUrl = fileupload.data('remove');
                    
                    //We can just mock a success response when no url is configured
                    if(!deleteUrl){
                        def.resolve({errors: []});
                        return;
                    }
                    
                    MDB.sendAjaxRequest(deleteUrl, { file: filename, id: fileupload.data('id') }, 'POST')
                        .done(function() { def.resolve.apply(def, arguments) })
                        .fail(function() { def.reject.apply(def, arguments) });
                }).promise();
                
                prom.done(function(response) {
                    if(response.errors && response.errors.length > 0) {
                        MDB.Notify.bootstrapWarning(errors.join('<br />'));
                    } else {
                        row.remove();
                        option.remove();

                        removeDeleteAllButton(dropzone);
                    }
                });
            }
            
            function removeDeleteAllButton(dropzone){
                //Delete all button should only be deleted once all rows have been deleted
                if(dropzone.find('.file-row').length !== 0){
                    return;
                }
                
                dropzone.find('.delete-all-btn')
                    .remove();
            }

            function downloadFile(fileupload, filename) {
                var downloadUrl = fileupload.data('download');
                window.location.href = (downloadUrl + '&filename=' + filename);
            }

            function promptDelete(filename, callback) {
                MDB.promptWithIcon(MDB.loadResourceString('Dpn_CampaignManager_Advanced_Delete_File_Title'), 
                    sprintf(MDB.loadResourceString('Dpn_CampaignManager_Advanced_Delete_File_Body'), filename), 
                    'fa fa-trash-o text-danger', function(ok) {
                    if(ok) {
                        callback(filename);
                    }
                });
            }
        }
    });
})();

$(document).ready(function () {
    MDB.initMdbFileUploads();
});
